import ImportInfluencerErrorLog from "@/Component/Admin/ImportInfluencer/ErrorLog";

const ImportInfluencerPage = async ({ params }: { params: Promise<{ id: string }>; }) => {
    const resolvedParams = await params;
    const id = Array.isArray(resolvedParams.id)
        ? resolvedParams.id[0]
        : resolvedParams.id;
    return <ImportInfluencerErrorLog fileManagerID={id} />;
};

export default ImportInfluencerPage;
